export const EChangeMonitoringActions = {
	enableSelected: 'enableSelected',
	enableCurrentPage: 'enableCurrentPage',
	enableAll: 'enableAll',
	enableAllFiltered: 'enableAllFiltered',
	disableSelected: 'disableSelected',
	disableCurrentPage: 'disableCurrentPage',
	disableAll: 'disableAll',
	disableAllFiltered: 'disableAllFiltered',
};

